<template>
    <div @click.stop>
        <div class="col-header-filter" ref="filterContainer" >
            <span class="header-label" v-if="showLabel">{{ label }}</span>
            <el-popover
                v-if="filterType"
                ref="popoverRef"
                trigger="click"
                placement="bottom"
                :width="popoverWidthVal"
                @show="handlePopoverShow"
                @hide="handlePopoverHide"
                v-bind="$attrs">
                <template v-slot:reference>
                    <i class="iconfont icon-search_senior" style="font-size: 10px; cursor: pointer;" @click="changeVisible"></i>
                </template>
                <div class="filter-content">
                    <div class="filter-box">
                        <el-input
                            v-if="filterType === 'input'"
                            v-model.trim="allSearchData[item.prop]"
                            :placeholder="`请输入${item.label}`"
                            size="mini"
                            @input="updateFilterValue(allSearchData[item.prop])"
                            @keyup.enter.native="confirmFilter"
                            clearable
                            @clear="handleClear"
                        />
                        <lots-select
                            v-else-if="filterType === 'select'"
                            class="filter-select"
                            :optionsKey="item.optionsKey"
                            collapse-tags
                            filterable
                            :placeholder="item.filterPlaceholder || '请选择'"
                            :multiple="item.filterMultiple !== false"
                            v-model="allSearchData[item.prop]"
                            clearable
                            style="width: 100%"
                            @change="updateFilterValue(allSearchData[item.prop])"
                            @clear="handleClear"
                        />
                        <el-select
                            v-else-if="filterType === 'localSelect'"
                            v-model="allSearchData[item.prop]"
                            :placeholder="item.filterPlaceholder || '请选择'"
                            :multiple="item.filterMultiple !== false"
                            collapse-tags
                            filterable
                            clearable
                            size="mini"
                            style="width: 100%"
                            @change="updateFilterValue(allSearchData[item.prop])"
                            @clear="handleClear">
                            <el-option
                                v-for="opt in item.options"
                                :key="opt.value"
                                :label="opt.label"
                                :value="opt.value"
                            />
                        </el-select>
                        <el-date-picker
                            v-else-if="filterType === 'dateRange'"
                            v-model="allSearchData[item.prop]"
                            type="daterange"
                            size="mini"
                            :start-placeholder="item.startPlaceholder || '开始日期'"
                            :end-placeholder="item.endPlaceholder || '结束日期'"
                            :format="item.filterDateFormat || 'yyyy-MM-dd'"
                            :value-format="item.filterValueFormat || 'yyyy-MM-dd'"
                            style="width: 100%"
                            :default-time="['00:00:00', '23:59:59']"
                            @change="updateFilterValue(allSearchData[item.prop]); confirmFilter()"
                            clearable
                            @clear="handleClear"
                        />
                        <lots-md-input
                            v-else-if="filterType === 'advance'"
                            ref="mdInputRef"
                            :label="filterValue"
                            :config="item"
                            @change="handleAdvanceChange" />
                        <slot
                            v-else-if="filterType === 'slot'"
                            name="filter-slot"
                            v-bind="{ filterValue, updateFilterValue, clearFilter, emitFilter }">
                        </slot>
                    </div>
                    <div class="filter-actions" v-if="filterType !== 'advance' && filterType !== 'slot'">
                        <el-button class="gray-btn" size="mini" @click="resetFilter">重置</el-button>
                        <lots-button type="primary" size="mini" @click="confirmFilter">搜索</lots-button>
                    </div>
                    <div class="filter-actions" v-if="filterType === 'advance'">
                        <el-button class="gray-btn" size="mini" @click="resetAdvanceFilter">重置</el-button>
                    </div>
                </div>
            </el-popover>
        </div>
    </div>

</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import lotsSelect from '@/components/lots/lotsSelect/Index';
import lotsMdInput from '@/components/lots/lotsMdInput';
import { filterEventBus } from '@/modules/mdm/views/customerModules/biddingAccountManage/filterEventBus';

export default {
    name: 'ColHeaderFilter',
    components: { lotsButton, lotsSelect, lotsMdInput },
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        popoverWidth: {
            type: Number,
            default: 200
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, { emit, root }) {
        const filterValue = ref(null);
        const allSearchData = ref({});
        const popoverVisible = ref(false);
        const popoverRef = ref(null);
        const mdInputRef = ref(null);

        const onCloseAllFilters = () => {
            if (popoverVisible.value) {
                doClose();
            }
        };

        const doClose = () => {
            if (popoverRef.value) {
                popoverRef.value.doClose();
            }
        };

        const handlePopoverShow = () => {
            popoverVisible.value = true;
            emit('filter-open', props.item.prop);
        };

        const handlePopoverHide = () => {
            popoverVisible.value = false;
            emit('filter-close', props.item.prop);
        };

        const confirmFilter = () => {
            const value = getFilterValue();
            emit('filter', { prop: props.item.prop, value, filterType: props.item.filterType, allSearchData: allSearchData.value });
        };

        const handleClear = () => {
            emit('filter', { prop: props.item.prop, value: null, filterType: props.item.filterType, allSearchData: allSearchData.value });
        };

        const emitFilter = (value) => {
            emit('filter', { prop: props.item.prop, value, filterType: props.item.filterType, allSearchData: allSearchData.value });
        };

        const clearFilter = () => {
            filterValue.value = null;
            allSearchData.value = {};
            handleClear();
        };

        const resetFilter = () => {
            filterValue.value = null;
            allSearchData.value = {};
            handleClear();
        };

        const filterType = computed(() => props.item.filterType || '');
        const label = computed(() => props.item.label || '');
        const popoverWidthVal = computed(() => props.popoverWidth);

        const updateFilterValue = (value) => {
            filterValue.value = value;
            allSearchData.value = allSearchData.value || {};
            allSearchData.value[props.item.prop] = value;
        };

        const resetAdvanceFilter = () => {
            filterValue.value = null;
            allSearchData.value = {};
            if (mdInputRef.value) {
                mdInputRef.value.clear && mdInputRef.value.clear();
                mdInputRef.value.value = '';
            }
            emit('filter', { prop: props.item.prop, value: null, filterType: props.item.filterType, allSearchData: allSearchData.value });
        };

        const handleAdvanceChange = (data) => {
            const valueKey = props.item.value || 'value';
            filterValue.value = data;
            emit('filter', { prop: props.item.prop, value: data[valueKey], filterType: props.item.filterType, allSearchData: allSearchData.value });
        };

        const getFilterValue = () => {
            return filterValue.value;
        };
        const changeVisible = () => {
            filterEventBus.$emit('close-other-filters', props.item.prop);
        };
        const onCloseOtherFilters = (currentProp) => {
            if (currentProp !== props.item.prop && popoverVisible.value) {
                doClose();
            }
        };
        onMounted(() => {
            filterEventBus.$on('close-all-filters', onCloseAllFilters);
            filterEventBus.$on('close-other-filters', onCloseOtherFilters);
        });

        onBeforeUnmount(() => {
            filterEventBus.$off('close-all-filters', onCloseAllFilters);
            filterEventBus.$off('close-other-filters', onCloseOtherFilters);
        });

        return {
            filterValue,
            allSearchData,
            popoverVisible,
            popoverRef,
            mdInputRef,
            changeVisible,
            doClose,
            handlePopoverShow,
            handlePopoverHide,
            confirmFilter,
            handleClear,
            emitFilter,
            clearFilter,
            resetFilter,
            updateFilterValue,
            resetAdvanceFilter,
            handleAdvanceChange,
            onCloseAllFilters,
            onCloseOtherFilters,
            filterType,
            label,
            popoverWidthVal
        };
    }
};
</script>

<style lang="less">
.col-header-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    white-space: nowrap;

    .header-label {
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .el-popover {
        margin-left: 4px;
    }
}

.filter-content {
    padding: 5px;

    .filter-box {
        min-height: 32px;
    }

    .filter-actions {
        margin-top: 15px;
        display: flex;
        justify-content: flex-end;
        gap: 5px;

        .gray-btn {
            background: #f5f5f5;
            color: #666;
            border-color: #f5f5f5;

            &:hover {
                color: #4285f5;
            }
        }
    }
}

.filter-select {
    width: 100%;

    .el-input,
    .el-input input {
        height: 28px !important;
    }

    .el-input__icon {
        line-height: 28px !important;
    }
}
</style>
